/* eslint-disable no-invalid-this */
/*
 * @Description: 头部注释: ...
 * @Version: 1.0.0
 * @Autor: michael_jier
 * @Date: 2021-06-28 17:44:49
 * @LastEditors: michael_jier
 * @LastEditTime: 2021-09-14 11:41:45
 */
/**
 * 登录
 * @param {object} {token}
 * return Pomise
 */
  import { getUserInfo } from '@/api/apiAll';
  import Cookie from 'js-cookie'

  export default async function({token, onFinished} = {token: ''}) {
    const store = this.$store
    token && Cookie.set('token', token, { expires: 10 });
    const { uin } = store.getters['channelInfo']
    const res = await getUserInfo({
      uin
    })
    if (res.code === 200 && res.errorCode === 0) {
      store.commit('set_userInfo', res.data)
      store.dispatch('PostInfo')
      onFinished && onFinished()
    }
    return this
  }
